import React, { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import {
  Nav,
  NavbarContainer,
  LogoLink,
  LogoMark,
  LogoText,
  NavItems,
  NavLinkItem,
  NavLink,
  NavPill,
  ButtonContainer,
  IconLink,
  ResumeButton,
  MobileIcon,
  MobileTop,
  MobileClose,
  MobileMenu,
  MobileLinks,
  MobileLink,
  MobileFooter,
  MobileSocials,
} from "./NavbarStyledComponent";
import { FiMenu, FiX, FiGithub, FiLinkedin, FiDownload } from "react-icons/fi";
import { Bio } from "../../data/constants";
import { useActiveSection } from "../../hooks/useActiveSection";

const NAV_ITEMS = [
  { id: "about", label: "About" },
  { id: "experience", label: "Experience" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Projects" },
  { id: "education", label: "Education" },
  { id: "contact", label: "Contact" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const active = useActiveSection(NAV_ITEMS.map((n) => n.id));

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <Nav $scrolled={scrolled}>
      <NavbarContainer>
        <LogoLink href="#top">
          <LogoMark>A</LogoMark>
          <LogoText>Jayson.</LogoText>
        </LogoLink>

        <NavItems>
          {NAV_ITEMS.map((item) => (
            <NavLinkItem key={item.id}>
              {active === item.id && (
                <NavPill layoutId="nav-pill" transition={{ type: "spring", stiffness: 380, damping: 32 }} />
              )}
              <NavLink href={`#${item.id}`} $active={active === item.id}>
                {item.label}
              </NavLink>
            </NavLinkItem>
          ))}
        </NavItems>

        <ButtonContainer>
          <IconLink href={Bio.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FiGithub />
          </IconLink>
          <IconLink href={Bio.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FiLinkedin />
          </IconLink>
          <ResumeButton href={Bio.resume} target="_blank" rel="noopener noreferrer">
            <FiDownload /> Resume
          </ResumeButton>
        </ButtonContainer>

        <MobileIcon onClick={() => setIsOpen(true)} aria-label="Open menu">
          <FiMenu />
        </MobileIcon>
      </NavbarContainer>

      <AnimatePresence>
        {isOpen && (
          <>
            <MobileTop>
              <MobileClose onClick={() => setIsOpen(false)} aria-label="Close menu">
                <FiX />
              </MobileClose>
            </MobileTop>
            <MobileMenu
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <MobileLinks>
                {NAV_ITEMS.map((item, i) => (
                  <MobileLink
                    key={item.id}
                    href={`#${item.id}`}
                    onClick={() => setIsOpen(false)}
                    initial={{ opacity: 0, x: -24 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.08 + i * 0.05, duration: 0.4 }}
                  >
                    {item.label}
                  </MobileLink>
                ))}
              </MobileLinks>
              <MobileFooter>
                <ResumeButton
                  href={Bio.resume}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ width: "100%", justifyContent: "center", padding: "16px" }}
                >
                  <FiDownload /> Download Resume
                </ResumeButton>
                <MobileSocials>
                  <IconLink href={Bio.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                    <FiGithub />
                  </IconLink>
                  <IconLink href={Bio.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <FiLinkedin />
                  </IconLink>
                </MobileSocials>
              </MobileFooter>
            </MobileMenu>
          </>
        )}
      </AnimatePresence>
    </Nav>
  );
};

export default Navbar;
